import React, { useState } from 'react';
import ButtonOptions from '../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../components/NovoSistema/HeaderButtons';
import AjusteDeSaldo from './AjusteDeSaldo';
import Cadastros from './Cadastros';
import ConsultaDeMovimentacao from './ConsultaDeMovimentacao';
import ConsultaDeSaldoKardex from './ConsultaDeSaldoKardex';
import Entrada from './Entrada';
import Recalculo from './Recalculo';
import Relatorios from './Relatorios';
import RequisicaoDeMaterial from './RequisicaoDeMaterial';

export default function Estoque() {
  const [option, setOption] = useState('');
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Ajuste de Saldo"
          border="#30336b"
          active={option === 'Ajuste de Saldo' ? true : false}
          yourFunction={() => setOption('Ajuste de Saldo')}
        />
        <ButtonOptions
          buttonName="Consulta de Movimentação"
          border="#30336b"
          active={option === 'Consulta de Movimentação' ? true : false}
          yourFunction={() => setOption('Consulta de Movimentação')}
        />
        <ButtonOptions
          buttonName="Consulta Saldo/Kardex"
          border="#30336b"
          active={option === 'Consulta Saldo/Kardex' ? true : false}
          yourFunction={() => setOption('Consulta Saldo/Kardex')}
        />
        <ButtonOptions
          buttonName="Entrada"
          border="#30336b"
          active={option === 'Entrada' ? true : false}
          yourFunction={() => setOption('Entrada')}
        />
        <ButtonOptions
          buttonName="Recálculo"
          border="#30336b"
          active={option === 'Recálculo' ? true : false}
          yourFunction={() => setOption('Recálculo')}
        />
        <ButtonOptions
          buttonName="Requisição de Material"
          border="#30336b"
          active={option === 'Requisição de Material' ? true : false}
          yourFunction={() => setOption('Requisição de Material')}
        />
        <ButtonOptions
          buttonName="Cadastros"
          border="#30336b"
          active={option === 'Cadastros' ? true : false}
          yourFunction={() => setOption('Cadastros')}
        />
        <ButtonOptions
          buttonName="Relatórios"
          border="#30336b"
          active={option === 'Relatórios' ? true : false}
          yourFunction={() => setOption('Relatórios')}
        />
      </HeaderButtons>
      {option === 'Ajuste de Saldo' && <AjusteDeSaldo />}
      {option === 'Consulta de Movimentação' && <ConsultaDeMovimentacao />}
      {option === 'Consulta Saldo/Kardex' && <ConsultaDeSaldoKardex />}
      {option === 'Entrada' && <Entrada />}
      {option === 'Recálculo' && <Recalculo />}
      {option === 'Requisição de Material' && <RequisicaoDeMaterial />}
      {option === 'Cadastros' && <Cadastros />}
      {option === 'Relatórios' && <Relatorios />}
    </main>
  );
}
